import { useCallback, useEffect, useReducer, useState } from "react";
import styled from "styled-components";
import './style.scss';

type Props = {}

const DATA: string[] = [
    '5 lutego 2008 roku',
    '8 sierpnia 1956 roku',
    '12 września 1993 roku',
    '18 listopada 1948 roku',
    '23 stycznia 1976 roku',
    '10 czerwca 2005 roku',
    '3 lipca 2001 roku',
    '1 kwietnia 1988 roku',
    '4 lutego 1998 roku',
    '17 października 1977 roku',
    '13 grudnia 1981 roku',
    '4 czerwca 1989 roku',
    '16 kwietnia 1989 roku',
    '24 sierpnia 1939 roku',
    '1 maja 2004 roku',
    '7 stycznia 1993 roku',
].sort(() => (Math.random() - .5));

const TextContainer = styled.div``;

const Task301Game: React.FC<Props> = () => {

    const [openned, incOpen] = useReducer((state) => {
        return (state + 1) % DATA.length;
    }, 0);

    const [mode, setMode] = useState<'rotating' | 'setting' | 'stale'>('rotating');

    const onRandomizeClick = useCallback(() => {
        setMode('setting');

        setTimeout(() => {
            setMode('stale');
        }, 1000);
    }, [setMode]);

    const onResetClick = useCallback(() => {
        setMode('rotating');
    }, [setMode]);

    useEffect(() => {
        if (mode === 'rotating' || mode === 'setting') {
            const id = setInterval(() => {
                incOpen();
            }, 100);

            return () => {
                clearInterval(id);
            }
        }
    }, [incOpen, mode]);

    return <div className="task-404-game">
        <div className={`window ${mode}`}>
            {DATA.map((text, index) => {
                return <TextContainer className={`text ${openned === index ? 'showed' : 'hidden'}`} key={index}>
                    {text}
                </TextContainer>
            })}
        </div>
        <div className="buttons">
            {mode === 'rotating' && <button onClick={onRandomizeClick}>Losuj</button>}
            {mode === 'stale' && <button onClick={onResetClick}>Od nowa</button>}
        </div>
    </div>
};

export default Task301Game;
